import template from './reportEditor.template.html';

export default {
  template,
  bindings: {
    reports: '<',
    ticketLabels: '<',
    milestoneStages: '<',
    mergeFields: '<',
    additionalMergeFields: '<',
    onApplied: '&',
    onClosed: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $scope,
      $mdMedia,
      $timeout,
      uiService,
      actionService,
      dateTimeService,
      Report,
      ReportFilter,
      ReportAggregation,
      reportService,
      reportsService,
      eventService,
      REPORT
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.report = Report.blank();
      ctrl.reportsList = null;
      ctrl.chips = [];
      ctrl.chipsAssigned = [];
      ctrl.fields = [];
      ctrl.useDeletedDeals = false;
      ctrl.objects = Object.assign([], REPORT.QUICK.OBJECTS);
      ctrl.time = Object.assign([], REPORT.QUICK.TIME);
      ctrl.statuses = Object.assign([], REPORT.QUICK.STATUSES);
      ctrl.anniversaries = Object.assign([], REPORT.QUICK.ANNIVERSARY);
      ctrl.filters = Object.assign([], REPORT.FILTERS);
      ctrl.filtersDate = _.filter(ctrl.filters, (f) => f.key.indexOf('date.') === 0);
      ctrl.filtersStatus = _.filter(ctrl.filters, (f) => f.key.indexOf('status.') === 0);
      ctrl.filtersDetails = _.filter(ctrl.filters, (f) => f.key.indexOf('filter.') === 0);
      ctrl.aggregations = Object.assign([], REPORT.AGGREGATIONS);
      ctrl.availableTime = ctrl.time;
      ctrl.availableStatuses = ctrl.statuses;
      ctrl.values = Object.assign([], REPORT.QUICK.VALUES);
      ctrl.stateFilter = '';
      ctrl.hasSelection = false;
      ctrl.showReportConfiguration = true;
      ctrl.showReportContents = true;
      ctrl.showSelectedFields = true;
      ctrl.showAllFields = false;
      ctrl.showFilters = false;
      ctrl.showFiltersDate = false;
      ctrl.showFiltersStatus = false;
      ctrl.showFiltersDetails = false;
      ctrl.showAggregations = false;
      ctrl.isEditing = false;
      ctrl.isReady = false;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onReportsOpen(() => {
          if ($rootScope.IsEnterprise) {
            if ($rootScope.CurrentOrganization.isBranch()) {
              ctrl.objects = reportService.quickObjectsForEnterpriseBranch();
            } else if ($rootScope.CurrentOrganization.isGroup()) {
              ctrl.objects = reportService.quickObjectsForEnterpriseGroup();
            } else {
              ctrl.objects = Object.assign([], REPORT.QUICK.OBJECTS);
            }
          } else {
            ctrl.objects = reportService.quickObjectsForOrganization();
          }

          /* eslint-disable no-param-reassign */
          const rejects = [
            'deal.lifetime',
            'deal.timeInWorkflow',
            'deal.timeLastStageChange',
            'deal.taskExpenses'
          ];
          _.forEach(ctrl.mergeFields, (field) => {
            if (field?.name?.toLowerCase() === 'deal - general information') {
              _.remove(
                field?.value || [],
                (v) => v?.key === rejects[0] || v?.key === rejects[3]
              );
            }
            if (field?.name?.toLowerCase() === 'deal - status') {
              _.remove(
                field?.value || [],
                (v) => v?.key === rejects[1] || v?.key === rejects[2]
              );
            }
          });
          ctrl.mergeProperties = [].concat(ctrl.mergeFields);
          _.forEach(ctrl.mergeProperties, (mergeProperty) => {
            _.forEach(mergeProperty.value, (field) => {
              const partsArray = field.name.split(' - ');
              field.shortName = partsArray[2] !== '' ? partsArray[2] : partsArray[1];
              ctrl.chips.push({
                id: field.key,
                name:
                  partsArray[2] !== ''
                    ? [].concat(partsArray[0], partsArray[1]).join(' - ')
                    : partsArray[0],
                email: partsArray[2] !== '' ? partsArray[2] : partsArray[1]
              });
              ctrl.fields.push(field);
            });
            mergeProperty.isOpen = false;
          });
          ctrl.fields = ctrl.fields.concat(ctrl.additionalMergeFields);
          /* eslint-enable no-param-reassign */

          ctrl.isReady = true;
          eventService.intercomHide();
        });
      };

      ctrl.getField = (key) => _.find(ctrl.fields, (f) => f.key === key);

      ctrl.isSelectedField = (f) => ctrl.report.fields.indexOf(f.key || f) > -1;

      ctrl.selectedFields = () => ctrl.report.fields.length;

      ctrl.toggleField = (f) => {
        if (ctrl.isSelectedField(f)) {
          const idx = ctrl.report.fields.indexOf(f.key || f);
          ctrl.report.fields.splice(idx, 1);
        } else {
          ctrl.report.fields.push(f.key || f);
        }
      };

      ctrl.isSelectedAggregation = (a) =>
        _.findIndex(ctrl.report.aggregations, (al) => al.term === a.aggregations[0].term) > -1;

      ctrl.selectedAggregations = () => ctrl.report.aggregations.length;

      ctrl.toggleAggregation = (a) => {
        if (ctrl.isSelectedAggregation(a)) {
          ctrl.report.aggregations = [];
          const idx = ctrl.report.fields.indexOf(a.fields[0]);
          if (idx > -1) {
            ctrl.report.fields.splice(idx, 1);
          }
        } else {
          if (ctrl.report.aggregations.length) {
            const otherAggregations = _.reject(ctrl.aggregations, (ag) => ag === a);
            _.forEach(otherAggregations, (ag) => {
              if (ctrl.isSelectedAggregation(ag)) {
                ctrl.toggleAggregation(ag);
              }
            });
          }
          ctrl.report.aggregations = [].concat(a.aggregations);
          if (ctrl.report.fields.indexOf(a.fields[0]) === -1) {
            ctrl.report.fields.unshift(a.fields[0]);
          }
        }
      };

      ctrl.selectedFilters = (fl) => _.filter(fl, (f) => f.isSelected === true).length;

      ctrl.toggleFilter = (f) => {
        /* eslint-disable no-param-reassign */
        f.isSelected = !f.isSelected;
        /* eslint-enable no-param-reassign */
      };

      ctrl.toggleStatus = () => {
        if (ctrl.report.quick.isTicket || ctrl.report.quick.isProduct) {
          $timeout(() => {
            ctrl.report.quick.statuses = ctrl.report.quick.statuses.slice(-1);
          });
        }
      };

      ctrl.isSelectedStatus = (s) => ctrl.report.quick.statuses.indexOf(s) > -1;

      ctrl.isSelectedMilestoneStages = (s) => ctrl.report.quick.stages.indexOf(s) > -1;

      ctrl.isSelectedLabels = (l) => ctrl.report.quick.labels.indexOf(l) > -1;

      ctrl.toggleQuickReportType = (prop) => {
        const allProps = [
          'isLeaderBoard',
          'isPipeline',
          'isConversion',
          'isTicket',
          'isProduct',
          'isContacts'
        ];
        if (prop) {
          const val = _.get(ctrl.report, `quick.${prop}`);
          if (val === true) {
            const otherProps = _.reject(allProps, (p) => p === prop);
            _.forEach(otherProps, (p) => _.set(ctrl.report, `quick.${p}`, !val));
          } else {
            _.set(ctrl.report, `quick.isLeaderBoard`, true);
          }
        }
        if (ctrl.report.quick.isLeaderBoard === true) {
          ctrl.availableTime = { ...ctrl.time };
        } else if (ctrl.report.quick.isPipeline) {
          if (ctrl.report.quick.statuses.length && ctrl.report.quick.stages.length) {
            ctrl.report.quick.statuses = [];
          }
        } else if (ctrl.report.quick.isProduct) {
          ctrl.report.quick.value = undefined;
        } else if (ctrl.report.quick.isContacts) {
          ctrl.availableTime = _.reject(
            ctrl.time,
            (t) => _.startsWith(t.key, 'time.anyTime') || _.startsWith(t.key, 'time.last')
          );
          ctrl.report.quick.timeFrom = undefined;
          ctrl.report.quick.timeTo = undefined;
          ctrl.report.quick.value = undefined;
        } else {
          ctrl.availableTime = _.reject(ctrl.time, (t) => _.startsWith(t.key, 'time.next'));
        }

        if (ctrl.report.quick.isConversion) {
          ctrl.availableStatuses = _.reject(
            ctrl.statuses,
            (t) =>
              t.key === 'status.stale' ||
              t.key === 'status.frozen' ||
              t.key === 'status.won' ||
              t.key === 'status.withdrawn' ||
              t.key === 'status.declined' ||
              t.key === 'status.lost' ||
              t.key === 'status.settled'
          );
        } else {
          ctrl.availableStatuses = { ...ctrl.statuses };
        }
      };

      ctrl.toggleReportType = () => {
        const isQuick = !ctrl.report.isQuick;
        const { name } = ctrl.report;
        ctrl.report = Report.blank();
        ctrl.report.name = name;
        ctrl.report.isQuick = isQuick;
      };

      ctrl.reportEdit = (event, data) => {
        event.stopPropagation();
        ctrl.filters = [];
        ctrl.filtersDate = [];
        ctrl.filtersStatus = [];
        ctrl.filtersDetails = [];
        $timeout(() => {
          ctrl.report = data || Report.blank();
          ctrl.toggleQuickReportType();
          ctrl.filters = JSON.parse(JSON.stringify(REPORT.FILTERS));
          _.forEach(ctrl.filters, (filter) => {
            const matchingFilter = _.find(
              ctrl.report.filters,
              (fl) => fl.term === filter.filters[0].term
            );
            if (matchingFilter) {
              const matchingFilterSettings = _.find(
                filter.filters,
                (ff) => ff.type === filter.type
              );
              const configuredFilter = _.find(
                ctrl.report.filters,
                (fl) =>
                  fl.term === matchingFilterSettings.term &&
                  fl.type === matchingFilterSettings.type
              );
              if (configuredFilter) {
                /* eslint-disable no-param-reassign */
                filter.isSelected = true;
                filter.value = configuredFilter.value;
                /* eslint-enable no-param-reassign */
              } else {
                /* eslint-disable no-param-reassign */
                filter.isSelected = false;
                filter.value = null;
                /* eslint-disable no-param-reassign */
              }
            }
          });
          ctrl.filtersDate = _.filter(ctrl.filters, (f) => f.key.indexOf('date.') === 0);
          ctrl.filtersStatus = _.filter(ctrl.filters, (f) => f.key.indexOf('status.') === 0);
          ctrl.filtersDetails = _.filter(ctrl.filters, (f) => f.key.indexOf('filter.') === 0);
          ctrl.showSelectedFields = false;
          ctrl.showAllFields = false;
          ctrl.showFiltersStatus = false;
          ctrl.showFiltersDate = false;
          ctrl.showFiltersDetails = false;
          ctrl.showAggregations = false;
          ctrl.isEditing = true;
        });
      };

      ctrl.reportSave = ($event) => {
        $event.stopPropagation();
        ctrl.isEditing = false;
        if (ctrl.report.isQuick) {
          if (ctrl.report.quick.isConversion) {
            ctrl.report.quick.statuses = []
              .concat(ctrl.report.quick.statuses)
              .concat('status.settled');
          }
          const object =
            !ctrl.report.quick.isTicket &&
            !ctrl.report.quick.isProduct &&
            !ctrl.report.quick.isContacts
              ? _.find(ctrl.objects, (o) => o.key === ctrl.report.quick.object)
              : [];
          let time;
          const { timeFrom } = ctrl.report.quick;
          const { timeTo } = ctrl.report.quick;
          if (timeFrom && timeTo) {
            time = {
              key: 'time.absolute',
              name: 'Absolute time',
              fieldsMap: [],
              filters: [
                {
                  term: '{timeStampTerm}',
                  type: 'date',
                  value: { fromAbs: timeFrom, toAbs: timeTo }
                }
              ]
            };
          } else {
            time = _.find(ctrl.time, (o) => o.key === ctrl.report.quick.time);
          }
          const statuses =
            !ctrl.report.quick.isProduct && !ctrl.report.quick.isContacts
              ? _.filter(ctrl.statuses, (o) => ctrl.report.quick.statuses.indexOf(o.key) > -1)
              : [];
          const anniversary = ctrl.report.quick.isContacts
            ? _.find(ctrl.anniversaries, (o) => o.key === ctrl.report.quick.anniversary)
            : [];
          const stages =
            (ctrl.report.quick.isPipeline || ctrl.report.quick.isTicket) &&
            ctrl.milestoneStages.length
              ? _.filter(
                  ctrl.milestoneStages,
                  (o) => ctrl.report.quick.stages.indexOf(o.key) > -1
                )
              : [];
          const labels = !ctrl.report.quick.isContacts
            ? _.filter(ctrl.ticketLabels, (o) => ctrl.report.quick.labels.indexOf(o.key) > -1)
            : [];
          const lender = _.find([], (o) => o.key === ctrl.report.quick.lender);
          const ticket = ctrl.report.quick.isTicket ? REPORT.QUICK.TICKET : [];
          const product = ctrl.report.quick.isProduct ? REPORT.QUICK.PRODUCT : [];
          const value =
            !ctrl.report.quick.isProduct && !ctrl.report.quick.isContacts
              ? _.find(ctrl.values, (o) => o.key === ctrl.report.quick.value)
              : [];
          const state =
            ctrl.stateFilter === ''
              ? []
              : {
                  filters: [
                    {
                      term: 'relOrganization.organization.address.state',
                      type: 'string',
                      value: ctrl.stateFilter
                    }
                  ]
                };
          const settingsContainers = _.compact(
            []
              .concat(object)
              .concat(time)
              .concat(stages)
              .concat(labels)
              .concat(lender)
              .concat(anniversary)
              .concat(ticket)
              .concat(product)
              .concat(statuses)
              .concat(value)
              .concat(state)
              .concat({
                filters: [
                  {
                    term: 'isActive',
                    type: 'boolean',
                    value: ctrl.useDeletedDeals ? 'false' : 'true'
                  }
                ]
              })
          );

          const settings = reportService.extractReportSettings(
            settingsContainers,
            value ? value.key : undefined,
            ctrl.report.quick
          );
          ctrl.report.fields = _.uniq(_.compact(settings.fields));
          ctrl.report.filters = settings.filters;
          ctrl.report.aggregations = settings.aggregations;
        } else {
          ctrl.report.filters = [];
          const selectedFilters = _.filter(ctrl.filters, (f) => f.isSelected === true);
          _.forEach(selectedFilters, (f) => {
            _.forEach(f.filters, (inner) => {
              const filter = inner;
              if (f.filters.length < 2 || f.filters.indexOf(inner) > 0) {
                // Check needs to be present for Filter Options which have multiple Filters defined
                // This is case with Date Filters which define both Bool and Date
                // Bool (first) is predefined, Date (second) receives the set value

                if (f.value.fromAbs || f.value.toAbs) {
                  // eslint-disable-next-line no-param-reassign
                  f.value.fromAbs = f.value.fromAbs
                    ? dateTimeService.setDate(
                        f.value.fromAbs,
                        $rootScope.CurrentTimeZone(),
                        true
                      )
                    : '';
                  // eslint-disable-next-line no-param-reassign
                  f.value.toAbs = f.value.toAbs
                    ? dateTimeService.setDate(f.value.toAbs, $rootScope.CurrentTimeZone(), true)
                    : '';
                }
                filter.value = f.value;
              }
              ctrl.report.filters.push(filter);
            });
          });
          const isActiveIndex = _.findIndex(ctrl.report.filters, (f) => f.term === 'isActive');
          if (isActiveIndex > -1) {
            ctrl.report.filters.splice(isActiveIndex, 1);
          }
          ctrl.report.filters = ctrl.report.filters.concat({
            term: 'isActive',
            type: 'boolean',
            value: ctrl.useDeletedDeals ? 'false' : 'true'
          });
        }

        if (ctrl.report.fields.length) {
          if (!ctrl.report.id) {
            ctrl.report.name =
              ctrl.report.name !== ''
                ? ctrl.report.name
                : `New Report ${ctrl.reports.length + 1}`;
            const r = angular.copy(ctrl.report);
            reportService.createReport(r).then((data) => {
              if (data.status) {
                reportsService.clearCache();
                r.id = data.id;
                ctrl.reportsList.setDataAppend(r);
                ctrl.reportApply(null, r);
              }
            });
          } else {
            const r = angular.copy(ctrl.report);
            reportService.updateReport(r).then((data) => {
              if (data.status) {
                reportsService.clearCache();
                ctrl.reportsList.setDataReplace(r);
                ctrl.reportApply(null, r);
              }
            });
          }
        } else {
          uiService.toast({
            text: {
              p1: 'At least one of',
              p2: 'report field(s)',
              p3: 'must be selected'
            },
            warn: true
          });
        }
      };

      ctrl.reportDelete = () =>
        actionService
          .deleteDocuments(
            ctrl.reportsList.getSelected(),
            reportService.deleteReport,
            ctrl.reportsList.removeData,
            'report(s)'
          )
          .then(() => {
            reportsService.clearCache();
            ctrl.hasSelection = false;
          });

      ctrl.reportDuplicate = () =>
        actionService
          .duplicateDocuments(
            ctrl.reportsList.getSelected(),
            reportService.readReport,
            reportService.createReport,
            ctrl.reportsList.setDataAppend,
            'name',
            ' copy',
            'report(s)'
          )
          .then(() => {
            reportsService.clearCache();
            ctrl.hasSelection = false;
          });

      ctrl.reportApply = ($event, report) => {
        ctrl.isReady = false;
        if (ctrl.onApplied) {
          $timeout(() => {
            ctrl.onApplied({ report });
          }, 250);
        }
        eventService.reportsClose();
      };

      ctrl.close = () => {
        ctrl.isReady = false;
        eventService.reportsClose();
        eventService.intercomShow();
      };

      ctrl.listReportChange = (list, data, isSelected) => {
        ctrl.hasSelection = isSelected || list.isSelectedAny();
      };

      ctrl.listReportReady = (list) => {
        ctrl.reportsList = list;
      };

      ctrl.sortOptions = {
        placeholder: 'drag-place-holder',
        connectWith: 'st-report div.report-fields-container',
        cursor: 'move',
        opacity: 0.65,
        start: (e, ui) => {
          ui.item.show().addClass('ghost');
        },
        helper: (event, element) => $(element).clone().addClass('dragging'),
        update: () => {},
        stop: (e, ui) => {
          ui.item.show().removeClass('ghost');
        }
      };

      ctrl.chipsFilter = (query) =>
        query
          ? _.filter(
              ctrl.chips,
              (chip) =>
                chip.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                chip.email.toLowerCase().indexOf(query.toLowerCase()) > -1
            ).slice(0, 250)
          : [];

      $scope.$watchCollection('$ctrl.chipsAssigned', () => {
        if (ctrl.chipsAssigned && ctrl.chipsAssigned.length) {
          ctrl.toggleField(_.find(ctrl.fields, (f) => f.key === ctrl.chipsAssigned[0].id));
          ctrl.chipsAssigned = [];
        }
      });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (
          (changes.reports && changes.reports.currentValue) ||
          (changes.fields && changes.fields.currentValue)
        ) {
          ctrl.initialize();
        }
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
